import type { ComponentPropsWithRef } from "react";
import { styled } from "styled-components";

import { PlusIcon } from "common/components";
import { Dropdown } from "common/components/dropdown/Dropdown";
import { breakpoints } from "common/styles";
import { useSelector } from "common/utilities/react-redux";
import { TopicImageExportButton } from "domains/topicDetail/components/advancedOptions/TopicImageExportButton";
import { TopicPresentationOptionsButton } from "domains/topicDetail/components/advancedOptions/TopicPresentationExportButton";
import { getTmSelectedTopic } from "domains/transformationMap/selectors";
import { getCanUseTopicImageExport, getCanUseTopicPresentationExport } from "entities/permissions/selectors";

const StyledContainer = styled.div`
  display: flex;
`;

const StyledIcon = styled(PlusIcon)`
  width: 14px;
  height: 14px;
  margin-left: 16px;
`;

const StyledButton = styled.div`
  display: none;
  box-sizing: border-box;
  padding: 10px 16px;
  height: 40px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.proLabelBackground};
  color: ${({ theme }) => theme.colors.proLabelText};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;

  @media ${breakpoints.large} {
    display: flex;
  }
`;

const Button = (props: ComponentPropsWithRef<"div">) => (
  <StyledButton {...props} data-title="map-advanced-options-button">
    PRO
    <StyledIcon />
  </StyledButton>
);

export const AdvancedOptionsDropdown = () => {
  const topic = useSelector(getTmSelectedTopic);
  const canUseTopicImageExport = useSelector(getCanUseTopicImageExport);
  const canUseTopicPresentationExport = useSelector(getCanUseTopicPresentationExport);

  const items = [
    {
      key: "export-image",
      component: TopicImageExportButton,
      shouldShow: canUseTopicImageExport,
    },
    {
      key: "export-presentation",
      component: TopicPresentationOptionsButton,
      shouldShow: canUseTopicPresentationExport,
    },
  ];

  if (!topic?.id) {
    return null;
  }

  return (
    <StyledContainer>
      <Dropdown
        alignment="right"
        ButtonElement={Button}
        isProDropdown
        items={items.filter(({ shouldShow }) => shouldShow)}
      />
    </StyledContainer>
  );
};
